import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Location } from '@angular/common';
import { ApiService } from 'src/app/services/api.service';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'fury-page-add-edit',
  templateUrl: './page-add-edit.component.html',
  styleUrls: ['./page-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
  encapsulation: ViewEncapsulation.None
})
export class PageAddEditComponent implements OnInit, OnDestroy {
  ngUnSubscribe = new Subject<void>();
  settingForm!:  FormGroup;
  settingName!: string;
  settingDetails!: any;
  bannerImage:any;
  otherBadgeImage:any;
  @ViewChild('image_one') private image_one: ElementRef;
  @ViewChild('image_two') private image_two: ElementRef;
  pageName: any = [
    {
      value: 'home',
      name: 'home'
    },
    {
      value: 'offer',
      name: 'offer'
    },
    {
      value: 'estimate',
      name: 'estimate'
    },
    {
      value: 'popUp',
      name: 'popup'
    }]
  pageContentList: any;
  editorConfig = {
    allowedContent: false,
    toolbarGroups: [
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
      { name: 'links' }, { name: 'insert' },
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
      { name: 'styles' },
      { name: 'colors' }
    ],
    forcePasteAsPlainText: false,
    image_previewText: ' '
  };
  constructor(
    public api: ApiService, 
    private router: Router, 
    private ar: ActivatedRoute, 
    private _location: Location
    ) { }

  ngOnInit(): void {
    this.ar.params.pipe(takeUntil(this.ngUnSubscribe)).subscribe((res: any) => {
      this.settingName = res?.id;
      if(this.settingName){
        this.getDetail();
      }
    });
    this.formInit();
    if(this.settingName === 'offer' ||  this.settingName == 'home' || this.settingName == 'popUp'){
      this.settingForm.get('subHeading').setValidators(Validators.required);
    }
  }
  formInit() {
    this.settingForm = new FormGroup({
      pageName: new FormControl('', [Validators.required]),
      bannerText: new FormControl(''),
      isActive: new FormControl('', [Validators.required]),
      heading : new FormControl('', [Validators.required]),
      content : new FormControl('', [Validators.required]),
      lowPriceGuarantee: new FormControl(''),
      moneyBackGuarantee: new FormControl(''),
      subHeading: new FormControl('',),
      badge: new FormControl(null),
      otherBadge: new FormControl(null),
      startingPromotionDays: new FormControl(''),
      startingPromotionHours: new FormControl(''),
      startingPromotionMinutes: new FormControl(''),
      startingPromotionSeconds: new FormControl(''),
      endingPromotionDays: new FormControl(''),
      endingPromotionHours: new FormControl(''),
      endingPromotionMinutes: new FormControl(''),
      endingPromotionSeconds: new FormControl(''),
      resetPromotion: new FormControl(false),
      promotionText: new FormControl('', [Validators.required]),
      promotionBannerText: new FormControl('', [Validators.required]),
      formFirstStepText: new FormControl('', [Validators.required]),
      formSecondStepText: new FormControl('', [Validators.required]),
      unitNumberText: new FormControl('', [Validators.required]),
      propertyInformationText: new FormControl('', [Validators.required]),
      mobileTitle: new FormControl(''),
      mobileDescription: new FormControl(''),
    });
  }

  checkPromotionTimerValidations():boolean{
    const startingPromotionDays = this.settingForm.get('startingPromotionDays');
    const startingPromotionHours = this.settingForm.get('startingPromotionHours');
    const startingPromotionMinutes = this.settingForm.get('startingPromotionMinutes');
    const startingPromotionSeconds = this.settingForm.get('startingPromotionSeconds');
    const endingPromotionDays = this.settingForm.get('endingPromotionDays');
    const endingPromotionHours = this.settingForm.get('endingPromotionHours');
    const endingPromotionMinutes = this.settingForm.get('endingPromotionMinutes');
    const endingPromotionSeconds = this.settingForm.get('endingPromotionSeconds');

    if(this.settingForm.controls['pageName'].value === 'popUp') return true;

    if (Number(endingPromotionDays.value) < Number(startingPromotionDays.value)) {
      endingPromotionDays.setErrors({notValid: true});
      return false;
    } else if (
      Number(endingPromotionDays.value) === Number(startingPromotionDays.value) &&
      Number(endingPromotionHours.value) < Number(startingPromotionHours.value)
    ) {
      endingPromotionHours.setErrors({notValid: true});
      return false;
    } else if (
      Number(endingPromotionDays.value) === Number(startingPromotionDays.value) &&
      Number(endingPromotionHours.value) === Number(startingPromotionHours.value) &&
      Number(endingPromotionMinutes.value) < Number(startingPromotionMinutes.value)
    ) {
      endingPromotionMinutes.setErrors({notValid: true});
      return false;
    } else if (
      Number(endingPromotionDays.value) === Number(startingPromotionDays.value) &&
      Number(endingPromotionHours.value) === Number(startingPromotionHours.value) &&
      Number(endingPromotionMinutes.value) === Number(startingPromotionMinutes.value) &&
      Number(endingPromotionSeconds.value) <= Number(startingPromotionSeconds.value)
    ) {
      endingPromotionSeconds.setErrors({notValid: true});
      return false;
    } else {
      return true;
    }
  }

  getDetail(){
    this.api.get('admin/settings/page-content/get-single-page-content-settings/'+this.settingName)
    .pipe(takeUntil(this.ngUnSubscribe))
    .subscribe((res: any) => {
     if(res?.body){
      this.settingDetails = res?.body?.pageContentSettings;
      this.settingForm.patchValue({
        pageName: this.settingName,
        bannerText: res?.body?.pageContentSettings?.bannerText,
        isActive: Number(res?.body?.pageContentSettings?.isActive),
        content: res?.body?.pageContentSettings?.content,
        subHeading: res?.body?.pageContentSettings?.subHeading,
        moneyBackGuarantee: res?.body?.pageContentSettings?.moneyBackGuarantee,
        lowPriceGuarantee: res?.body?.pageContentSettings?.lowPriceGuarantee,
        heading: res?.body?.pageContentSettings?.heading,
        startingPromotionDays : res?.body?.pageContentSettings?.startingPromotionDays,
        startingPromotionHours : res?.body?.pageContentSettings?.startingPromotionHours,
        startingPromotionMinutes : res?.body?.pageContentSettings?.startingPromotionMinutes,
        startingPromotionSeconds : res?.body?.pageContentSettings?.startingPromotionSeconds,
        endingPromotionDays : res?.body?.pageContentSettings?.endingPromotionDays,
        endingPromotionHours : res?.body?.pageContentSettings?.endingPromotionHours,
        endingPromotionMinutes : res?.body?.pageContentSettings?.endingPromotionMinutes,
        endingPromotionSeconds : res?.body?.pageContentSettings?.endingPromotionSeconds,
        promotionBannerText: res?.body?.pageContentSettings?.promotionBannerText,
        promotionText: res?.body?.pageContentSettings?.promotionText,
        formFirstStepText: res?.body?.pageContentSettings?.formFirstStepText,
        formSecondStepText: res?.body?.pageContentSettings?.formSecondStepText,
        unitNumberText: res?.body?.pageContentSettings?.unitNumberText,
        propertyInformationText: res?.body?.pageContentSettings?.propertyInformationText,
        mobileTitle: res?.body?.pageContentSettings?.mobileTitle,
        mobileDescription: res?.body?.pageContentSettings?.mobileDescription,
      })
      this.bannerImage = res?.body?.pageContentSettings?.badge;
      this.otherBadgeImage = res?.body?.pageContentSettings?.otherBadge;
     }
    })
  };

  onImageUpload(event: any) {
    if (event.target.files[0].type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file : File;
      file = event.target.files[0];
      this.settingForm.patchValue({ badge: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.bannerImage = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.api.alert(ErrorText.ImageRestriction, 'error');
    }
  };
  otherBadgeImageUpload(event: any) {
    if (event.target.files[0]?.type === 'image/jpeg' || event.target.files[0].type === 'image/png' || event.target.files[0].type === 'image/jpg') {
      let file : File;
      file = event.target.files[0];
      this.settingForm.patchValue({ otherBadge: file });
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.otherBadgeImage = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    } else {
      this.api.alert(ErrorText.ImageRestriction, 'error');
    }
  };

  removeBadge(badgeType: string){ 
    if(this.settingDetails?.badge){
      this.api.delete(`admin/settings/page-content/delete-page-content-badge/${this.settingForm.value.pageName}/${badgeType}`)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res:any)=>{
        if(res){
          this.getDetail();
        }
      }, err =>{
        this.api.alert('Please try again', ErrorType.Error);
      })
    } else {
        this.settingForm.patchValue({badge : null});
        this.image_one.nativeElement.value = null;
        this.bannerImage = null;
    }
    
  }
  
  removeOtherBadge(badgeType: string){ 
    if(this.settingDetails?.otherBadge){
      this.api.delete(`admin/settings/page-content/delete-page-content-badge/${this.settingForm.value.pageName}/${badgeType}`)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res:any)=>{
        if(res){
          this.getDetail();
        }
      }, err =>{
        this.api.alert('Please try again', ErrorType.Error);
      })
    } else { 
        this.settingForm.patchValue({otherBadge : null});
        this.image_two.nativeElement.value = null;
        this.otherBadgeImage = null; 
    }
    
  }
  
  save() {
    if (this.settingForm.valid && this.checkPromotionTimerValidations()) {
      const settingsFormValue = this.settingForm.value;
      if(this.settingForm.controls['pageName'].value === 'popUp'){
        delete settingsFormValue.bannerText;
        delete settingsFormValue.startingPromotionDays;
        delete settingsFormValue.startingPromotionHours;
        delete settingsFormValue.startingPromotionMinutes;
        delete settingsFormValue.startingPromotionSeconds;
        delete settingsFormValue.endingPromotionDays;
        delete settingsFormValue.endingPromotionHours;
        delete settingsFormValue.endingPromotionMinutes;
        delete settingsFormValue.endingPromotionSeconds;
        delete settingsFormValue.isReset;
      }
      const data : FormData = new FormData();
      Object.keys(settingsFormValue).forEach(fieldName => {
        const value = settingsFormValue[fieldName];
      if (value !== null && value !== undefined) {
        if(fieldName === 'resetPromotion'){
          data.append('isReset', value ? '1' : '0');
        } else {
          data.append(fieldName, value);
        }
       
      }
      })   
      this.api.postMultiData(`admin/settings/page-content/save-page-content-settings/${this.settingForm.value.pageName}`, data)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {          
          if (res.body) {
            this.api.alert(res.body.message, 'success');
            this._location.back();
          } else { this.api.alert(res.body.message, 'warning') }
        }, error: (err: HttpErrorResponse) => {
          if (err) { this.api.alert(err?.message, 'error') }
        }
      })
    } else {
      this.settingForm.markAllAsTouched();
    }
  }
  validatePromotionTimerField(event: any){
    const startingPromotionDays = this.settingForm.get('startingPromotionDays');
    const startingPromotionHours = this.settingForm.get('startingPromotionHours');
    const startingPromotionMinutes = this.settingForm.get('startingPromotionMinutes');
    const startingPromotionSeconds = this.settingForm.get('startingPromotionSeconds');
    const endingPromotionDays = this.settingForm.get('endingPromotionDays');
    const endingPromotionHours = this.settingForm.get('endingPromotionHours');
    const endingPromotionMinutes = this.settingForm.get('endingPromotionMinutes');
    const endingPromotionSeconds = this.settingForm.get('endingPromotionSeconds');
    const bannerText = this.settingForm.get('bannerText');
    this.validateMobileFields(event);
    if(event !== 'popUp'){
      startingPromotionDays.setValidators([Validators.required]);
      startingPromotionHours.setValidators( [Validators.required, Validators.min(0), Validators.max(23)]);
      startingPromotionMinutes.setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
      startingPromotionSeconds.setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
      endingPromotionDays.setValidators([Validators.required]);
      endingPromotionHours.setValidators( [Validators.required, Validators.min(0), Validators.max(23)]);
      endingPromotionMinutes.setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
      endingPromotionSeconds.setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
      bannerText.setValidators([Validators.required]);
    } else {
      startingPromotionDays.clearValidators();
      startingPromotionHours.clearValidators();
      startingPromotionMinutes.clearValidators();
      startingPromotionSeconds.clearValidators();
      endingPromotionDays.clearValidators();
      endingPromotionHours.clearValidators();
      endingPromotionMinutes.clearValidators();
      endingPromotionSeconds.clearValidators();
      bannerText.clearValidators();
    }
    startingPromotionDays.updateValueAndValidity();
    startingPromotionHours.updateValueAndValidity();
    startingPromotionMinutes.updateValueAndValidity();
    startingPromotionSeconds.updateValueAndValidity();
    endingPromotionDays.updateValueAndValidity();
    endingPromotionHours.updateValueAndValidity();
    endingPromotionMinutes.updateValueAndValidity();
    endingPromotionSeconds.updateValueAndValidity();
    bannerText.updateValueAndValidity();
  }
  validateMobileFields(event: string){
    const mobileTitle = this.settingForm.get('mobileTitle');
    const mobileDescription = this.settingForm.get('mobileDescription');
    if(event.toLowerCase() === 'popup'){
      mobileTitle.setValidators([Validators.required]);
      mobileDescription.setValidators([Validators.required]);
    } else {
      mobileTitle.clearValidators();
      mobileDescription.clearValidators();
    }
    mobileTitle.updateValueAndValidity();
    mobileDescription.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }

}
